<div
  class="{{ extraClass }}"
  [ngClass]="{ 'p-sm': !contentSlot.children.length && !forOverview, 'cursor-pointer': !filter.disable }"
>
  <div #contentSlot (click)="!filter.disable ? filterMenuTrigger.openMenu() : undefined">
    <ng-content></ng-content>
  </div>
  @if (!contentSlot.children.length) {
    <div
      class="min-w-max flex items-center text-sm leading-sm text-txt {{ extraTriggerClass }}"
      [ngClass]="{
        'text-primary!': filter && filter.items && filter.items.length > 0 && !forOverview,
        'justify-end': rightAlign,
        'justify-center': centerAlign,
        'p-base': forOverview
      }"
      (click)="!filter.disable ? filterMenuTrigger.openMenu() : undefined"
    >
      @if (!forOverview && filter.items && filter.items.length > 0) {
        <div class="mr-xs flex">
          <svg-icon key="filter" class="text-sm!"></svg-icon>
        </div>
      }
      <span>
        {{ filter.label }}
      </span>
      @if (appliedRulesText) {
        <span class="ml-[6px] min-w-max font-semibold">{{ appliedRulesText }}</span>
      }
      @if (filter.infoTitle) {
        <div
          [llaTippy]="infoTooltipTemplate"
          [llaTippyProps]="tooltipOption"
          class="hidden md:flex ml-[6px] text-primary"
        >
          <svg-icon key="info-circle" class="text-xs!"></svg-icon>
        </div>
      }
      @if (sortDirection && showSortArrow) {
        <div
          class="ml-[6px] flex text-txt-secondary"
          [ngClass]="{ 'rotate-180': sortDirection === 'desc' }"
        >
          @if (sortDirection) {
            <svg-icon key="arrow-up-full" class="text-2xs!"></svg-icon>
          }
        </div>
      }
      @if (forOverview) {
        <div class="ml-auto flex text-txt-disabled">
          <svg-icon key="search" class="text-xs!"></svg-icon>
        </div>
      }
    </div>
  }
  <div [matMenuTriggerFor]="filterMenu" #filterMenuTrigger="matMenuTrigger"></div>
</div>

<mat-menu
  #filterMenu="matMenu"
  [hasBackdrop]="true"
  backdropClass="mg-menu-backdrop"
  class="lla-filter-menu"
  (closed)="onMenuClose()"
>
  <div [id]="filter.key + 'filtertop'"></div>
  <div
    class="relative p-base pb-0 flex flex-col w-[320px] beautyScroll bg-contrast border border-ui-separator"
    [ngClass]="{
      'md:w-[460px]!': filter.columnType === tableColumnTypes.date && !onlySort,
      'md:w-[370px]!': filter.columnType === tableColumnTypes.number && !onlySort,
      'md:w-[700px]! 2xl:w-[1350px]! 2xl:max-h-[740px]!': filter.shopSelector,
      'max-h-[450px]!': filter.columnType === tableColumnTypes.checkbox && !onlySort,
      'w-max!': onlySort
    }"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    @if (!filter.hideSorting) {
      <div class="flex items-center" [ngClass]="{ 'pb-base': onlySort }">
        <div
          class="sort-btn mr-sm"
          [ngClass]="{ 'sort-btn-active': sortDirection === 'asc' }"
          (click)="
            filterChanged.emit({
              sort:
                sort?.active === (filter.sortColumnName ?? filter.key) && sort?.direction === 'asc'
                  ? null
                  : { active: filter.sortColumnName ?? filter.key, direction: 'asc' }
            })
          "
        >
          {{ filter.columnType === tableColumnTypes.number ? 'Low to high' : 'Ascending' }}
        </div>
        <div
          class="sort-btn"
          [ngClass]="{ 'sort-btn-active': sortDirection === 'desc' }"
          (click)="
            filterChanged.emit({
              sort:
                sort?.active === (filter.sortColumnName ?? filter.key) && sort?.direction === 'desc'
                  ? null
                  : { active: filter.sortColumnName ?? filter.key, direction: 'desc' }
            })
          "
        >
          {{ filter.columnType === tableColumnTypes.number ? 'High to low' : 'Descending' }}
        </div>
      </div>
    }

    @if (!onlySort) {
      <form [formGroup]="form" (ngSubmit)="submit()">
        <!-- Aggregator -->
        @if (
          isAdvancedMode &&
          (filter.columnType === tableColumnTypes.text || filter.columnType === tableColumnTypes.number)
        ) {
          <lla-dropdown-menu
            class="block mt-sm w-full"
            [fullWidth]="true"
            [items]="aggregatorItems"
            [selectedItem]="form.get('aggregator')?.value"
            (selectedItemChanged)="form.get('aggregator')?.setValue($event)"
          >
          </lla-dropdown-menu>
        }
        <!-- Search box -->
        @if (filter.searchable && filter.columnType === tableColumnTypes.checkbox) {
          <lla-input
            class="block mb-xs sticky -top-base bg-contrast -mt-base"
            controlName="searchText"
            size="small"
            placeholder="Search"
            icon="search"
            [normalInputId]="filter.key + 'input'"
          ></lla-input>
        }
        @for (
          itemForm of $any(itemsControl['controls']);
          track itemForm.get('ruleId')?.value;
          let i = $index
        ) {
          <div formArrayName="items" [ngClass]="{ '-mt-sm': i > 0 }">
            <ng-container [formGroup]="itemForm">
              @switch (filter.columnType) {
                @case (tableColumnTypes.checkbox) {
                  @if (filter.shopSelector) {
                    <lla-shops-selector
                      [ngClass]="{ 'block mt-base': !filter.hideSorting }"
                      [numberOfColumns]="4"
                      controlName="value"
                      [searchInputId]="filter.key + 'input'"
                    ></lla-shops-selector>
                  } @else {
                    <div
                      class="flex flex-col gap-sm"
                      [ngClass]="{ 'mt-base': !filter.searchable && !filter.hideSorting }"
                    >
                      @for (item of visibleListItems; track item) {
                        <div class="flex items-center cursor-pointer">
                          <lla-checkbox
                            [item]="item"
                            extraLabelClass="text-sm! text-txt!"
                            controlName="value"
                          ></lla-checkbox>
                        </div>
                      }
                    </div>
                  }
                }
                @case (tableColumnTypes.radio) {
                  <div class="mt-base flex flex-col gap-sm">
                    @for (item of filter.listItems ?? []; track item) {
                      <div class="flex items-center cursor-pointer">
                        <lla-radio
                          [item]="item"
                          labelClass="text-sm! text-txt!"
                          [circleSize]="16"
                          controlName="value"
                        ></lla-radio>
                      </div>
                    }
                  </div>
                }
                @case (tableColumnTypes.date) {
                  <lla-range-date-picker
                    class="block mt-base"
                    [standalone]="true"
                    [value]="selectedDateInfo"
                    maxDate="Today"
                    (valueChanged)="
                      onDateChange(false, itemForm.get('value'), itemForm.get('extraValue'), $event)
                    "
                    (initailValueChanged)="
                      onDateChange(true, itemForm.get('value'), itemForm.get('extraValue'), $event)
                    "
                  ></lla-range-date-picker>
                }
                @default {
                  @let isEmptinessRule = isEmptinessOperator(itemForm.get('operator')?.value);
                  @if (filter.columnType === tableColumnTypes.number || !isEmptinessRule) {
                    <div class="flex">
                      @if (filter.columnType === tableColumnTypes.number || isAdvancedMode) {
                        <lla-dropdown-menu
                          class="mr-sm mt-sm"
                          [class.flex-1]="isEmptinessRule"
                          [items]="operators"
                          [selectedItem]="itemForm.get('operator')?.value"
                          (selectedItemChanged)="itemForm.get('operator')?.setValue($event)"
                        >
                        </lla-dropdown-menu>
                      }
                      @if (!isEmptinessRule) {
                        <lla-input
                          class="flex-1"
                          controlName="value"
                          [showErrorMessage]="false"
                          [type]="$any(filter.columnType)"
                          size="small"
                          placeholder="Value"
                          [normalInputId]="filter.key + 'input'"
                        ></lla-input>
                      }
                      @if (isAdvancedMode) {
                        <div
                          class="flex ml-sm pt-xl text-txt-disabled hover:text-txt cursor-pointer"
                          (click)="removeRule(i)"
                        >
                          <svg-icon key="close" class="text-sm!"></svg-icon>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="mt-sm"></div>
                  }
                }
              }
            </ng-container>
          </div>
        }

        <!-- Add new rule -->
        @if (
          isAdvancedMode &&
          (filter.columnType === tableColumnTypes.text || filter.columnType === tableColumnTypes.number)
        ) {
          <lla-button
            class="block w-max"
            type="button"
            size="medium-shrink"
            variant="ghost"
            icon="plus"
            (click)="addNewRule()"
          >
            Add rule
          </lla-button>
        }

        <!-- IsEmpty / IsNotEmpty Rules -->
        @if (filter.columnType === tableColumnTypes.text) {
          <lla-checkbox-element
            class="block pt-sm"
            label="Is Empty"
            [value]="hasEmptyRule()"
            (changed)="setHasEmptyRule($event)"
          ></lla-checkbox-element>
          <lla-checkbox-element
            class="block pt-sm"
            label="Is Not Empty"
            [value]="hasNotEmptyRule()"
            (changed)="setHasNotEmptyRule($event)"
          ></lla-checkbox-element>
        }
      </form>
      <div
        class="sticky bg-contrast left-0 bottom-0 pb-base pt-base flex items-center justify-between"
        [ngClass]="{
          'pt-xs!':
            filter.columnType === tableColumnTypes.number || filter.columnType === tableColumnTypes.text,
          'justify-end!': !filter.clearableDate && filter.columnType === tableColumnTypes.date
        }"
      >
        @if (filter.shopSelector) {
          <lla-button
            size="medium"
            variant="ghost"
            icon="close-circle"
            extraBtnClass="py-0! px-xs!"
            (click)="
              filterMenuTrigger.closeMenu();
              filterChanged.emit({
                shouldDelete: true
              })
            "
          >
            Clear all
          </lla-button>
          <lla-button
            size="medium"
            extraBtnClass="py-0! px-xs! text-primary!"
            variant="ghost"
            [disabled]="form.invalid"
            (click)="submit()"
          >
            Show results
            {{
              this.form.value?.items?.[0]?.value?.length
                ? '(' + this.form.value.items[0].value.length + ')'
                : ''
            }}
          </lla-button>
        } @else {
          @if (filter.clearableDate || filter.columnType !== tableColumnTypes.date) {
            <lla-button
              extraBtnClass="p-0! text-txt-secondary!"
              variant="ghost"
              size="medium"
              (click)="
                filterMenuTrigger.closeMenu();
                filterChanged.emit({
                  shouldDelete: true
                })
              "
            >
              Clear
            </lla-button>
          }
          <lla-button
            extraBtnClass="p-0! text-primary!"
            variant="ghost"
            size="medium"
            (click)="submit()"
          >
            Filter
          </lla-button>
        }
      </div>
    }
  </div>
</mat-menu>

<ng-template #infoTooltipTemplate>
  <div class="max-w-[300px] relative">
    <div class="text-sm leading-sm text-txt font-semibold pb-xs bg-contrast sticky top-0">
      {{ filter.infoTitle }}
    </div>
    @if (filter.infoSubtitle) {
      <div class="text-sm leading-sm text-txt">
        {{ filter.infoSubtitle }}
      </div>
    }
    @if (filter.infoList && filter.infoList.length > 0) {
      <div class="flex flex-wrap items-center gap-xs">
        @for (item of filter.infoList; track item; let isLast = $last) {
          <div class="capitalize text-sm leading-sm text-txt">{{ item }}{{ !isLast ? ',' : '' }}</div>
        }
      </div>
    }
  </div>
</ng-template>
